import { ConfirmModal } from '../../../shared/modal'

type ConfirmLockPublishedTemplatesModalProps = {
  /** Determines visibility of modal */
  isOpen: boolean
  /** Event callback when Confirm Button is triggered */
  onConfirm: () => void
}

const ConfirmLockPublishedTemplatesModal = ({
  isOpen,
  onConfirm
}: ConfirmLockPublishedTemplatesModalProps) => (
  <ConfirmModal
    confirmText="Lock Plans"
    isOpen={isOpen}
    onConfirm={onConfirm}
    title="Lock All Student Plans"
  >
    Are you sure you want to lock all student plans?
    <p>
      This action will prevent any modifications to all student plans. This is typically done at the
      end of a planning cycle to preserve plan integrity.
    </p>
    <p>
      <strong>Warning:</strong> This operation affects all student plans and cannot be easily
      undone.
    </p>
  </ConfirmModal>
)

export default ConfirmLockPublishedTemplatesModal
